import { Component, OnInit } from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import {FormArray, FormGroup} from "@angular/forms";
import {AsyncApiNode, AsyncApiNodeForm} from "./async-api";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";

const NODE_TYPE = 'endNode';

@Component({
  selector: 'async-api',
  templateUrl: './async-api.component.html',
  styleUrls: ['./async-api.component.scss']
})
export class AsyncApiComponent extends NodeBuilder implements OnInit {

  asyncApiForm: FormGroup = undefined;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  get headers(): FormArray {
    return this.asyncApiForm.get("responseHeaders") as FormArray
  }

  set buildForm(stepData: any) {
    this.asyncApiForm = AsyncApiNode.toForm(stepData, this.canEdit);
    if (this.asyncApiForm.get('next').value === newStepValue) {
      this.asyncApiForm.get('next').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const raw_data: AsyncApiNodeForm = this.asyncApiForm.getRawValue()
    const stepData = new AsyncApiNode(raw_data.name, raw_data.description);
    stepData.setOutputVars(raw_data.responseHttpStatus, raw_data.responseBody, raw_data.responseHeaders, raw_data.next);

    return stepData.getStepData;
  }

  get isNodeValid(): boolean {
    this.asyncApiForm.markAllAsTouched();
    return this.asyncApiForm.valid;
  }

  addHeader() {
    this.headers.push(AsyncApiNode.getHeaderTemplate())
  }

  deleteHeader(index: number) {
    this.headers.removeAt(index);
  }

}
